jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});


var tabs = document.getElementsByClassName("tab");
var tabButtons = document.getElementsByClassName("tab-button");

    if (tabs.length > 0 && tabButtons.length > 0) {
        tabs[0].style.display = "block";
        tabButtons[0].classList.add("active");
    } else {
        console.log("No se encontraron elementos con la clase 'tab' o 'tab-button'.");
    }



 document.addEventListener("DOMContentLoaded", function () {
        const searchInput = document.getElementById("search-distribuidores");
        const blocks = document.querySelectorAll(".block-distribuidores");

        // Función para mostrar u ocultar bloques según la búsqueda
        function filterBlocks(query) {
            query = query.toLowerCase();

            blocks.forEach((block) => {
                const title = block.querySelector(".ciudad-distribuidores").textContent.toLowerCase();
                if (title.includes(query)) {
                    block.style.display = "flex";
                } else {
                    block.style.display = "none";
                }
            });
        }

        // Evento de escucha para la entrada de búsqueda
        searchInput.addEventListener("input", function () {
            const query = searchInput.value.trim();
            filterBlocks(query);
        });

        // Mostrar todos los bloques al cargar la página
        filterBlocks("");
    });

function changeTab(tabIndex) {
  // Ocultar todos los contenidos de las pestañas
  for (var i = 0; i < tabs.length; i++) {
    tabs[i].style.display = "none";
    tabButtons[i].classList.remove("active");
  }

  // Mostrar el contenido de la pestaña seleccionada
  tabs[tabIndex].style.display = "block";
  tabButtons[tabIndex].classList.add("active");
}
const topBar = document.getElementById('b_ed1245c2-90d5-4e45-985b-c841c911e75a');

if (topBar) {
    // Define los mensajes
    const messages = [
      `🎁 <b>ENVÍO GRATIS</b> por compras superiores o iguales a <b>$200.000</b>`,
      `<b>Compra hoy</b> y paga a cuotas con <img src="https://cdn.shopify.com/s/files/1/0763/3564/4950/files/image_4.png?v=1686157954">`
    ];

    let currentIndex = 0; // Índice del mensaje actual

    // Función para actualizar el contenido
    function updateMessage() {
        topBar.innerHTML = messages[currentIndex];
        currentIndex = (currentIndex + 1) % messages.length; // Alterna entre los índices
    }

    // Actualiza el mensaje cada 2 segundos
    setInterval(updateMessage, 5000);

    // Muestra el primer mensaje al cargar
    updateMessage();
} else {
    console.error('Elemento con ID "b_ed1245c2-90d5-4e45-985b-c841c911e75a" no encontrado.');
}